var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.411 15.1483C15.717 14.6384 15.8699 14.3834 16.0805 14.1983C16.2669 14.0344 16.4852 13.9108 16.7216 13.8353C16.9887 13.75 17.286 13.75 17.8806 13.75H42.1194C42.714 13.75 43.0113 13.75 43.2784 13.8353C43.5148 13.9108 43.7331 14.0344 43.9195 14.1983C44.1301 14.3834 44.283 14.6384 44.589 15.1483L50.8396 25.566C50.9923 25.8206 51.0687 25.9479 51.1227 26.0838C51.1707 26.2044 51.2054 26.3299 51.2264 26.458C51.25 26.6023 51.25 26.7508 51.25 27.0477V43.37C51.25 44.3781 51.25 44.8821 51.0538 45.2672C50.8812 45.6059 50.6059 45.8812 50.2672 46.0538C49.8821 46.25 49.3781 46.25 48.37 46.25H11.63C10.6219 46.25 10.1179 46.25 9.73282 46.0538C9.39413 45.8812 9.11876 45.6059 8.94619 45.2672C8.75 44.8821 8.75 44.3781 8.75 43.37V27.0477C8.75 26.7508 8.75 26.6023 8.7736 26.458C8.79456 26.3299 8.82932 26.2044 8.87727 26.0838C8.93128 25.9479 9.00766 25.8206 9.16042 25.566L15.411 15.1483Z",
    stroke: "#C7CACD",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.25 31.25H42.6915C41.9958 31.25 41.6479 31.25 41.386 31.4388C41.1242 31.6275 41.0142 31.9575 40.7942 32.6175L39.2058 37.3825C38.9858 38.0425 38.8758 38.3725 38.614 38.5612C38.3521 38.75 38.0042 38.75 37.3085 38.75H22.6915C21.9958 38.75 21.6479 38.75 21.386 38.5612C21.1242 38.3725 21.0142 38.0425 20.7942 37.3825L19.2058 32.6175C18.9858 31.9575 18.8758 31.6275 18.614 31.4388C18.3521 31.25 18.0042 31.25 17.3085 31.25H8.75",
    stroke: "#C7CACD",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive1);
export default __webpack_public_path__ + "static/media/archive1.184b8a09a8464e358a2304e08522519e.svg";
export { ForwardRef as ReactComponent };